export const categories = [
  {
    slug: 'story-appreciation',
    name: '故事赏析',
    description: '精选少妇白洁系列故事，感受都市女性的情感波澜与心灵蜕变',
    icon: 'ri-book-open-line',
    imageQuery: 'Warm%20elegant%20literary%20scene%20with%20soft%20amber%20lighting%20and%20open%20book%20on%20a%20wooden%20table%20surrounded%20by%20dried%20flowers%20and%20a%20cup%20of%20tea%2C%20feminine%20and%20cozy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20warm%20neutral%20tones%2C%20artistic%20composition',
  },
  {
    slug: 'character-analysis',
    name: '人物解读',
    description: '深度剖析少妇白洁及其身边人物的性格命运与情感逻辑',
    icon: 'ri-user-heart-line',
    imageQuery: 'Elegant%20silhouette%20of%20a%20woman%20by%20a%20window%20with%20soft%20natural%20light%20streaming%20through%20sheer%20curtains%2C%20contemplative%20mood%2C%20warm%20neutral%20color%20palette%2C%20artistic%20portrait%20style%2C%20dreamy%20atmosphere%2C%20feminine%20aesthetic',
  },
  {
    slug: 'emotional-topics',
    name: '情感话题',
    description: '围绕婚姻、家庭、自我成长等话题展开深入讨论与情感共鸣',
    icon: 'ri-heart-2-line',
    imageQuery: 'Two%20women%20having%20a%20heartfelt%20conversation%20in%20a%20cozy%20cafe%20with%20warm%20lighting%2C%20soft%20focus%20background%2C%20intimate%20atmosphere%2C%20warm%20amber%20and%20cream%20tones%2C%20emotional%20connection%2C%20cinematic%20composition',
  },
  {
    slug: 'literary-review',
    name: '文学评论',
    description: '从文学创作角度评析少妇白洁的叙事艺术与情感表达手法',
    icon: 'ri-article-line',
    imageQuery: 'Vintage%20writing%20desk%20with%20fountain%20pen%20and%20scattered%20manuscripts%2C%20warm%20glowing%20lamp%20light%2C%20soft%20shadows%2C%20literary%20atmosphere%2C%20cream%20and%20sepia%20tones%2C%20elegant%20composition%2C%20shallow%20depth%20of%20field',
  },
];